import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { map, switchMap } from 'rxjs/operators';
import {
  GetUserContactDetailsVm,
  UpdateUserContactDetailsCommand,
} from '../models';
import { CoreService } from '@app/core/services';
import { TeleworkerState } from '@app/core/models';
import { MfaService, NotUsingMfaModalResponse } from '@adreno-common';
import { of } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class UserContactService {
  private usersApi = `${environment.apiPath}/users`;

  contactDetails$ = this.http
    .get<GetUserContactDetailsVm>(`${this.usersApi}`)
    .pipe(map((vm) => vm));

  constructor(
    private http: HttpClient,
    private coreSvc: CoreService,
    private mfaSvc: MfaService
  ) {}

  resetAvatar() {
    this.http.put(`${this.usersApi}/resetavatar`, '').subscribe();
  }

  setUpdateDetailsState() {
    this.coreSvc.state = TeleworkerState.UpdateDetails;
  }

  updateContactDetails(
    details: Omit<UpdateUserContactDetailsCommand, 'mfaToken'>,
    sensitiveDataUpdated: boolean
  ) {
    return of(sensitiveDataUpdated).pipe(
      switchMap((sdu) =>
        sdu
          ? this.mfaSvc.getToken$()
          : of({ status: 'notusingmfa' } as NotUsingMfaModalResponse)
      ),
      switchMap((resp) => {
        if (resp.status == 'accepted' || resp.status == 'notusingmfa') {
          const cmd: UpdateUserContactDetailsCommand = {
            ...details,
            mfaToken: resp.mfaToken,
          };
          return this.http.put(`${this.usersApi}`, cmd).pipe(map(() => true));
        }
        return of(false);
      })
    );
  }
}
